import Compiler from 'workflow-compiler-provider';
import moment from 'moment';
import VWave from 'v-wave';
import vClickOutside from 'click-outside-vue3';
import FloatingVue from 'floating-vue';
import VueFinalModal from 'vue-final-modal';
import { initSentry } from 'igentify-node-shared/dist/configs/sentry';
import { VideoPlugin } from '@/modules/consent/modules/VideoPage/VideoPage.plugin';
import { SnackbarPlugin } from '@/shared/plugins/SnackbarPlugin/snackbar.plugin';
import { ModalPlugin } from '@/shared/plugins/ModalPlugin/modal.plugin';
import { NavigationProviderPlugin } from '@/modules/navigation/providers/navigation.provider.plugin';
import { asyncComponents } from '@/asyncComponents';
import { NavigationProvider } from '@/modules/navigation/providers/navigationProvider';
import { RegisterPlugin } from '@/modules/register/plugin';
import { configs } from '@/shared/configs';
import { i18n } from '@/i18n';
import 'floating-vue/dist/style.css';
import router from '@/router';
import store from '@/store';
import { IgcStatisticsService } from '@/shared/plugins/StatisticsPlugin/IgcStatisticsService';
import { beforeBreadcrumb, beforeSend } from '@/plugins.sentry';

moment.locale(configs.DEFAULT_LANG);

export async function initPlugins(app: any) {
  await initSentry({
    app,
    router,
    beforeSend,
    beforeBreadcrumb,
  });

  app.use(router);
  app.use(store);
  app.use(i18n);

  app.use(VueFinalModal);

  app.use(Compiler, { project: 'access-ui', dynamicComponents: asyncComponents });

  app.use(NavigationProviderPlugin);
  app.use(RegisterPlugin);
  app.use(ModalPlugin);
  app.use(SnackbarPlugin);
  app.use(VideoPlugin);

  app.config.globalProperties.$navigationProvider = new NavigationProvider();
  app.config.globalProperties.$igcStatistics = new IgcStatisticsService();
  app.use(VWave);
  app.use(vClickOutside);
  app.use(FloatingVue);
}
